@if (!checkresults) {
<div class="loading-status">
	@if (!error) {
	<div>
		<div class="logo-spin"></div>
		Loading...
	</div>
	}
	@if (error) {
	<div>
		<div class="logo-spin stopped"></div>
		{{error}}
	</div>
	}
</div>
}
@if (checkresults) {
<div>
	<table class="log">
		<thead>
			<tr>
				<th>Name</th>
				<th>CI Date</th>
				<th>IPS</th>
				<th>Warning Threshold</th>
				<th>Alarm Threshold</th>
			</tr>
		</thead>
		@for (row of checkresults; track row) {
		<tbody>
			<tr>
				<td>{{row.name}}</td>
				<td>{{row.date | datetime : "offset" : asset.time_offset_hours}}</td>
				<td [class.status-ok-fg]="row.value < row.warn" [class.status-warning-fg]="row.value >= row.warn && row.value < row.alarm" [class.status-error-fg]="row.value >= row.alarm">
					{{row.value}}</td>
				<td>{{row.warn}}</td>
				<td>{{row.alarm}}</td>
			</tr>
		</tbody>
		}
	</table>
	<button (click)="DownloadData()" title="Save this table as a CSV file" class="button block mt-3">
		Save to CSV
	</button>
</div>
}
<div class="panel compact">
	<div class="heading">Acknowledgement Log</div>
	<div class="content">
		@if (logs && !logs.length) {
		<div>
			No acknowledgement logs have been entered
		</div>
		}
		@if (logs && logs.length) {
		<div>
			<table class="log">
				<thead>
					<tr>
						<th>Date</th>
						<th>Entered by</th>
						<th>Summary</th>
						@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
						<th>
							Delete</th>
						}
					</tr>
				</thead>
				@for (log of logs; track log) {
				<tbody>
					<tr>
						<td>{{log.ts | datetime : "date" }}</td>
						<td>{{log.author_email}}</td>
						<td class="truncate" [title]="log.user_note"><span>{{log.user_note}}</span></td>
						@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
						<td>
							<app-action-button [action]="DeleteAcknowledgement" [args]="[log.vibe_check_ack_id]" [context]="this" btnClass="icon red" confirm="Are you sure?" processing="..."><i
									class="icon-trash"></i></app-action-button>
						</td>
						}
					</tr>
				</tbody>
				}
			</table>
		</div>
		}

		<div class="row mt-3">
			<div class="col-lg-8">
				<div class="mb-3">
					<label>Note (optional):</label>
					<div>
						<textarea [(ngModel)]="newSummary" class="form-control" style="min-height: 150px;"></textarea>
					</div>
				</div>
			</div>
			<div class="col-lg-4">
				<div class="mb-3">
					<label>Log vibe check acknowledgement:</label>
					<app-action-button [action]="SaveAcknowledgement" [context]="this" processing="Saving..." complete="Acknowledgement recorded"
						btnClass="green block">Acknowledge</app-action-button>
				</div>
			</div>
		</div>
	</div>
</div>